let state = {
    uploadimg: '',
    bless: {
        name: '',
        blessing: ''
    },
    mergeimg: ''
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/happyNewYear2018/state.js